import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as locationsActions from './locations.actions';
import * as locationsSelectors from './locations.selectors';
import { LocationsState } from './locations.reducer';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LocationInterface, LocationInterfaceWithId } from '@sk/sk-interfaces';


@Injectable()
export class LocationsFacade {
  locationsLoaded$ = this.store.pipe(select(locationsSelectors.getLocationsLoaded));
  allLocations$ = this.store.pipe(select(locationsSelectors.getLocations));
  allActiveLocations$ = this.store.pipe(select(locationsSelectors.getActiveLocations));

  allLocationsDictionary$ = this.store.pipe(select(locationsSelectors.getLocationsDictionary));

  addLocationsErrors$ = this.store.pipe(select(locationsSelectors.getAddLocationError));
  addLocationsSuccess$ = this.store.pipe(select(locationsSelectors.getAddLocationSuccess));

  updateLocationsErrors$ = this.store.pipe(select(locationsSelectors.getUpdateLocationError));
  updateLocationsSuccess$ = this.store.pipe(select(locationsSelectors.getUpdateLocationSuccess));

  locationsQueryError$ = this.store.pipe(select(locationsSelectors.getQueryLocationError));


  constructor(private store: Store<LocationsState>) {
  }


  loadLocationsFromFirestore() {
    this.store.dispatch(locationsActions.queryFireStoreLocations({}));
  }

  addLocation(location: LocationInterface) {
    const newLocation = {
      id: null,
      exists: false,
      ...location
    };
    this.store.dispatch(locationsActions.addLocation({
      location: newLocation
    }));
  }

  updateLocation(locationsId: string, changes: LocationInterfaceWithId) {
    this.store.dispatch(locationsActions.updateLocation({
      id: locationsId,
      changes
    }));
  }

  getLocationById(id: string): Observable<LocationInterfaceWithId> {
    return this.store.select(locationsSelectors.getLocations)
      .pipe(
        map(list => list.find(item => item.id === id))
      );
  }


}
